import React from 'react';
import PropTypes from 'prop-types';
import styles from '../badgeBase.module.scss';

const Pro = ({ user, className = '', style, title = 'Pro', ...rest }) => {
  if (!user || !user.pro) {
    return null;
  }

  const classNames = [styles.badge, styles.pro, className]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={classNames} style={style} title={title} {...rest}>
      <span className={styles.label}>Pro</span>
    </span>
  );
};

Pro.propTypes = {
  user: PropTypes.shape({
    pro: PropTypes.bool,
  }),
  className: PropTypes.string,
  style: PropTypes.object,
  title: PropTypes.string,
};

export default Pro;
